export function initializeCopyTicketInformation() {
    $('.btn-copy-information').on('click', function () {
        let i = 0;

        let inputs = [];
        let lastInput = '';
        $(this).closest('.ticket-container').find('input').each(function () {
            if ($(this).attr('type') === 'checkbox') {
                if ($(this).is(':checked')) {
                    inputs.push({name: $(this).data('name'), value: $(this).val()});
                }
            } else if ($(this).attr('type') === 'radio') {
                if ($(this).is(':checked')) {
                    inputs.push({name: $(this).data('name'), value: $(this).val()});
                }
            } else {
                inputs.push({name: $(this).data('name'), value: $(this).val()});
            }
        });

        $(this).closest('.ticket-container').find('select').each(function () {
            inputs.push({name: $(this).data('name'), value: $(this).val()});
        });

        $(this).closest('.ticket-container').find('textarea').each(function () {
            inputs.push({name: $(this).data('name'), value: $(this).val()});
        });

        $(this).closest('.tickets-container').find('.ticket-container').each(function () {
            let self = $(this);
            if (i > 0) {
                self.find('input').each(function () {
                    let element = $(this);

                    if (element.data('name') === 'display_name') {
                        if (inputs.some(input => input.name === 'display_name')) {
                            element.prop('checked', true);
                        } else {
                            element.prop('checked', false);
                        }
                    }

                    inputs.forEach(function (input) {
                        if (input.name === element.data('name')) {
                            if (element.attr('type') === 'radio' || element.attr('type') === 'checkbox') {
                                if (lastInput !== input.name) {
                                    element.prop('checked', false);
                                }

                                if (element.data('type') === 'waiver') {
                                    element.prop('checked', true);
                                } else {
                                    element.filter(`[value="${input.value}"`).prop('checked', true);
                                }

                                if (input.name === 'display_name' && input.value === 'on') {
                                    element.prop('checked', true);
                                }

                            } else {
                                element.val(input.value);
                            }
                        }

                        lastInput = input.name;
                    });
                });

                self.find('select').each(function () {
                    let element = $(this);
                    inputs.forEach(function (input) {
                        if (input.name === element.data('name')) {
                            element.val(input.value);

                            if (input.name.includes('[country]')) {
                                element.trigger('change');
                            }
                        }
                    });
                });

                self.find('textarea').each(function () {
                    let element = $(this);
                    inputs.forEach(function (input) {
                        if (input.name === element.data('name')) {
                            element.val(input.value);
                        }
                    });
                });
            }
            i++;
        });
    });
}
